import { render, staticRenderFns } from "./moreIcon.vue?vue&type=template&id=b9b3bfdc&"
import script from "./moreIcon.vue?vue&type=script&lang=js&"
export * from "./moreIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports